import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageSquare, MailOpen, FileText, Briefcase, ArrowUpRight } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { useLang } from "../../contexts/LanguageContext";
import { api } from "../../lib/api";

const Dashboard = () => {
  const { user } = useAuth();
  const { t } = useLang();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  const cards = stats ? [
    { l: t.admin.stats.total, v: stats.total_messages, icon: MessageSquare, to: "/admin/messages" },
    { l: t.admin.stats.unread, v: stats.unread_messages, icon: MailOpen, to: "/admin/messages" },
    { l: t.admin.stats.posts, v: stats.blog_posts, icon: FileText, to: "/admin/blog" },
    { l: t.admin.stats.portfolio, v: stats.portfolio_items, icon: Briefcase, to: "/admin/portfolio" },
  ] : [];

  return (
    <div data-testid="admin-dashboard">
      <div className="font-mono" style={{ fontSize: "0.7rem", letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase" }}>{t.admin.welcome}</div>
      <h1 className="font-display" style={{ fontSize: "3rem", fontWeight: 300, color: "var(--warm-off-white)", marginTop: 8, marginBottom: 40 }}>
        {user?.email?.split("@")[0]}<span style={{ color: "var(--gold)" }}>.</span>
      </h1>

      <div className="grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 20, marginBottom: 56 }}>
        {cards.map((c, i) => (
          <Link key={i} to={c.to} data-testid={`stat-card-${i}`} style={{ textDecoration: "none", padding: 28, background: "var(--rich-black-light)", border: "1px solid rgba(139,32,53,0.25)", display: "block", transition: "border-color 0.3s ease" }} onMouseEnter={(e) => (e.currentTarget.style.borderColor = "var(--gold)")} onMouseLeave={(e) => (e.currentTarget.style.borderColor = "rgba(139,32,53,0.25)")}>
            <div className="flex justify-between items-start">
              <c.icon size={20} color="var(--gold)" />
              <ArrowUpRight size={16} color="rgba(248,244,240,0.4)" />
            </div>
            <div className="font-display" style={{ fontSize: "3rem", fontWeight: 300, color: "var(--warm-off-white)", marginTop: 16, lineHeight: 1 }}>{c.v}</div>
            <div className="font-mono" style={{ fontSize: "0.7rem", letterSpacing: "0.18em", color: "rgba(248,244,240,0.55)", textTransform: "uppercase", marginTop: 8 }}>{c.l}</div>
          </Link>
        ))}
      </div>

      <h2 className="font-display" style={{ fontSize: "1.75rem", fontWeight: 400, color: "var(--warm-off-white)", marginBottom: 24 }}>{t.admin.recent}</h2>
      <div style={{ background: "var(--rich-black-light)", border: "1px solid rgba(139,32,53,0.25)" }}>
        {stats?.recent_messages?.length ? stats.recent_messages.map((m, i) => (
          <div key={m.id} style={{ padding: "20px 24px", borderBottom: i === stats.recent_messages.length - 1 ? "none" : "1px solid rgba(248,244,240,0.06)", display: "grid", gridTemplateColumns: "1fr 2fr auto", gap: 24, alignItems: "center" }}>
            <div>
              <div style={{ color: "var(--warm-off-white)", fontWeight: 500 }}>{m.name}</div>
              <div className="font-mono" style={{ fontSize: "0.75rem", color: "rgba(248,244,240,0.5)", marginTop: 4 }}>{m.email}</div>
            </div>
            <div style={{ color: "rgba(248,244,240,0.7)", fontSize: "0.9rem" }}>{m.service} • {m.budget}</div>
            <span className="font-mono" style={{ fontSize: "0.7rem", letterSpacing: "0.15em", padding: "4px 10px", border: "1px solid", borderColor: m.status === "new" ? "var(--gold)" : "rgba(248,244,240,0.2)", color: m.status === "new" ? "var(--gold)" : "rgba(248,244,240,0.6)", textTransform: "uppercase" }}>{m.status}</span>
          </div>
        )) : (
          <div style={{ padding: 24, color: "rgba(248,244,240,0.5)" }}>—</div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
